import { Model } from "@gaming/srvg-classes-core";
import { Competition } from "../Data/Competition";

export const COMPETITION_MODEL_COMPETITION = 'competition';

export class CompetitionModel extends Model {
    competition: Competition;

    constructor() {
        super();
        this.competition = null;
    }

    setCompetition( competition: Competition ) {
        this.setProperty( COMPETITION_MODEL_COMPETITION, competition );
    }

    destroy() {
        this.competition = null;
        super.destroy();
    }
}